import { callApiToServer } from "../callApi";

export async function addCategory(authtoken, categoryObject, categoryId) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      name: categoryObject.name,
      type: categoryObject.type,
    });

    let endUrl = "v1/auth/admin/add-category";
    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "POST", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
